import React, { useEffect, useState } from 'react';
import { Select } from 'components';
import { useDebounce } from 'hooks/useDebounce';

const DebounceMultiSelect = ({
  value = [],
  onChange,
  placeholder,
  fetchOptions,
  formatOptionLabel,
  limit = 10,
  minLength = 3,
  id,
  disabled = false,
}) => {
  const [input, setInput] = useState('');
  const debouncedInput = useDebounce(input, 500);
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const getOptions = async () => {
      if (debouncedInput.length < minLength) {
        setOptions([]);
        return;
      }

      setIsLoading(true);
      try {
        const res = await (await fetchOptions({ name: debouncedInput, limit })).json();
        if (res) {
          const fetched = res.results.result.map((item) => ({
            label: item.name,
            value: item.id,
          }));
          setOptions(fetched);
        }
      } catch (err) {
        console.error('Failed to fetch options', err);
        setOptions([]);
      } finally {
        setIsLoading(false);
      }
    };

    getOptions();
  }, [debouncedInput, limit, minLength]);

  const handleOnChange = (selected) => {
    onChange(selected || []);
  };

  // Keep the selected chips in the option list so react-select renders their labels; already
  // selected items are hidden from the menu by react-select in multi mode.
  const selectedValues = value.map((option) => option.value);
  const combinedOptions = [
    ...value,
    ...options.filter((option) => !selectedValues.includes(option.value)),
  ];

  return (
    <Select
      id={id}
      isMulti
      value={value}
      placeholder={placeholder}
      onChange={handleOnChange}
      options={combinedOptions}
      formatOptionLabel={formatOptionLabel}
      onInputChange={(val) => setInput(val)}
      isLoading={isLoading}
      disableFiltering
      disabled={disabled}
      isClearable
    />
  );
};

export default DebounceMultiSelect;
